import React, { useState } from "react";
import {
  ModalIDContainer,
  ModalHeader,
  ModalContent,
  ModalAction,
  PrimaryButton,
  SecondayButton,
  InfoContainer,
  InfoHeading,
  SampleID,
  ExampleList,
} from "./ModalUpdateId.styled";
import InfoIcon from "@material-ui/icons/Info";
import { NotificationManager } from "react-notifications";

const ModalUpdateId = ({ tpid, setTpId, handleUpdate }) => {
  const [editable, setEditable] = useState(false);
  const validateEmail = (id) => {
    return /^[^@]+@[^@]+\.[A-Z]+$/i.test(id);
  };
  const validateTPID = () => {
    if (tpid?.trim()) {
      if (validateEmail(tpid)) {
        handleUpdate();
      } else {
        NotificationManager.warning("Please check and enter valid Tp id");
      }
    } else {
      NotificationManager.warning("Please enter the Tp Id");
    }
  };
  return (
    <ModalIDContainer>
      <ModalHeader>
        <label>TP ID</label>
      </ModalHeader>
      <ModalContent>
        <label>Please update your TPID (UPN)</label>
        <InfoContainer>
          <InfoHeading>
            <InfoIcon />
            <label>
              Please take into account that the TPID has the UPN format as
              follows:
            </label>
          </InfoHeading>
          <SampleID>
            <label>username.1@location.teleperformance.com</label>
          </SampleID>
          <label className="example-lbl">
            Other examples with the different areas
          </label>
          <ExampleList>
            <label>jhonn.5@emea.teleperformance.com</label>
            <label>samir.5@nlsa.teleperformance.com</label>
            <label>frank.5@teleperformanceusa.com</label>
          </ExampleList>
        </InfoContainer>
        <input
          type="email"
          value={tpid}
          placeholder="Enter TP Id"
          disabled={!editable}
          onChange={(e) => setTpId(e.target.value)}
        />
      </ModalContent>
      <ModalAction>
        {!editable && (
          <SecondayButton onClick={() => setEditable(true)}>
            Edit
          </SecondayButton>
        )}
        <PrimaryButton onClick={() => validateTPID()}>
          {editable ? "Update" : "Confirm"}
        </PrimaryButton>
      </ModalAction>
    </ModalIDContainer>
  );
};

export default ModalUpdateId;
